import { Utilities } from './../../../services/common/Utility';
import { Product } from './../../../model/LteActiveSessions';
import { DataServiceService } from './../../../services/data-service.service';
import { Component, OnInit } from '@angular/core';
import { NzFormModule } from 'ng-zorro-antd/form';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { UserDetailResult } from 'src/app/model/UserDetail';
import { LteActiveSession } from 'src/app/model/LteActiveSessions';
import { UserModel } from 'src/app/model/UserModel';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { Router } from '@angular/router';
import { ActiveSessionsReqObj } from 'src/app/model/ApiRequests/ApiReqObj';
import { AccountService } from 'src/app/services/account.service';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';
import { usageReportModel } from 'src/app/model/usageReportModel';
import * as moment from 'moment';
import { ReportsService } from 'src/app/services/reports.service';
import { XDRModel } from 'src/app/model/XDRModel';
import { UsageRequests } from 'src/app/model/UsageRequests';
import { PaymentModel } from 'src/app/model/PaymentModel';
import { Payments } from 'src/app/model/Payments';
import { NzTableModule } from 'ng-zorro-antd/table';
 

@Component({
  selector: 'app-usage-report',
  templateUrl: './usage-report.component.html',
  styleUrls: ['./usage-report.component.css']
})
export class UsageReportComponent implements OnInit {
  usageForm: FormGroup;
  useagedate:string;
  useagedata: XDRModel[] =[];
  startdate: Date;
  enddate:Date;

  selectedAccount:number=0;

  paymentdata: Payments[] = [] ;
  

  initloading: boolean = true;
  userdetail: UserDetailResult;
  firstname: string;
  planname: string;
  planstatus: string;
  activeProducts2: any;
  activeProducts: LteActiveSession[];
  customer: any;
  MDN1: string;
  totalGb: string;
  currentUsage: string;
  daysLeft: string;
  progress: any;
  currentUser: UserModel;
  config: object;
  selectedOptions : any;
  customerBalance : string;

  accType:string;

  submitForm(): void 
  {
   
    var startdate =this.f. rangePicker.value[0];
    var enddate = this.f. rangePicker.value[0];
     
 
  }


 // convenience getter for easy access to form fields
 get f() { return this.usageForm.controls; }
  constructor(private fb: FormBuilder, private authenticationService:AuthenticationService, 
    private router :Router, private accountService:AccountService, private sharedService :SharedService, 
    private toastr: ToastrService, private dataServiceService: DataServiceService,
    private reportsService:ReportsService ) {


    this.currentUser = this.authenticationService.getCurrentUser();

    if (this.currentUser == null) {
      this.router.navigateByUrl("/signin");
      return;
    }


    this.currentUser = this.authenticationService.getCurrentUser();

    if(this.currentUser.i_Account == "0")
    {
   let KycStatus :string = this.currentUser.KycStatus;

   if(KycStatus)
   {
    if(KycStatus.toLowerCase() === "Rejected".toLowerCase() || KycStatus.toLowerCase() === "No Kyc".toLowerCase())
    { 
      this.router.navigate(['/kyc']); 

    }


   }
  }


    this.firstname = this.currentUser.FirstName;
    //console.log(this.currentUser);

    this.fetchAccounts();

 let secType:string ;
 
   this.dataServiceService.currentAccountType.subscribe(mess => {
    this.accType = mess;
    
    this.fetchAccounts();
    
   });



  }

  getSelectedAccount(i_account) {
    this.getAccountDetail(i_account);
  }
  fetchAccounts() {

    var my_object = this.currentUser;
    let activeSessionRequest : ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    activeSessionRequest.DownloadType = "ACC:GetDetail";
    console.log(my_object);
    if (my_object) {
      var iAccount = parseInt(my_object.i_Account);
      if (iAccount == 0)   //  customer with multiple accounts
      {
        //an individual
        activeSessionRequest.i_customer = parseInt(my_object.i_Customer);
        this.accountService.getCustomerBalance(activeSessionRequest.i_customer).subscribe(res=>{
          if(res.Result){
            this.sharedService.CustomerBalance = Math.round(res.Result);
            this.customerBalance = "₦" + this.sharedService.CustomerBalance.toLocaleString();
          }
        })
        this.setActiveSession(activeSessionRequest, this.accType);

      }
      else  // single account
      {
        activeSessionRequest.i_account = parseInt(my_object.i_Account);
        this.setActiveSession(activeSessionRequest, this.accType);
      }

    }
  }
  
  setActiveSession(model:ActiveSessionsReqObj, acctype:string){
    if(model){
      this.accountService.getActiveSessionsFromLteHttp(model).subscribe(res=>{

        if(res.Result == null || res.Status == 0){
          this.toastr.error("An error occured, Couldn't get active sessions", "Error");
          return;
        }

 
        if(acctype=="VOICE")
        {
          this.sharedService.activeSessions = res.Result.filter(a=>a.Product.Name.toLowerCase().includes("voice"));

        }
        else
        {
          this.sharedService.activeSessions = res.Result.filter(a=> !a.Product.Name.toLowerCase().includes("voice"));

        }
    



        this.activeProducts = this.sharedService.activeSessions.map(a=>{
          return <any>{
              AccountName : a.AccountName,
              ID : a.ID,
              i_account : a.i_account,
              Display : a.AccountName ? a.AccountName : a.ID
          }
        });

        var firstAcc = this.activeProducts[0];

        this.selectedOptions = {
          AccountName : firstAcc.AccountName,
          ID : firstAcc.ID,
          i_account : firstAcc.i_account,
          Display : firstAcc.AccountName ? firstAcc.AccountName : firstAcc.ID
      }
        this.MDN1 = this.activeProducts[0].AccountName ? this.activeProducts[0].AccountName : this.activeProducts[0].ID;
        this.getAccountDetail(this.activeProducts[0].i_account);

      },error=>{

        this.toastr.error(environment.GenericErrorMsg, "Error");

      })
    }
  }


  getAccountDetail(i_account) {

    let reqObj = {
      i_account: i_account
    }
    let millisecondsInDays = 86400000;
    let today = new Date().getTime();
    console.log(reqObj);
    var model : ActiveSessionsReqObj = {} as ActiveSessionsReqObj;
    model.i_account = i_account;
    model.DownloadType = "ACC:GetDetail";

    this.accountService.getActiveSessionsFromLteHttp(model)
      .subscribe(res => {
        if (res.Result.i_customer <= 0 && res.Result.i_account <= 0) {
          this.toastr.error(environment.GenericErrorMsg, "Error");
          return;
        }
        this.userdetail = res.Result[0];
        this.sharedService.userdetail = res.Result[0];
        
        var userdetail = this.sharedService.userdetail;
        this.planname = userdetail.Product.Name;
        this.setStatus(userdetail.AccountState);

        this.MDN1 = userdetail.AccountName ? userdetail.AccountName : userdetail.ID;
        let voiceproduct = userdetail.Product.Name.toLowerCase().includes("voice");
        if(voiceproduct){
          this.currentUsage = "₦" + userdetail.Balance.toLocaleString();
        }else{
          this.currentUsage = userdetail.DataVolume >= 1 ?
          Math.round(userdetail.DataVolume).toString() + "GB" : Math.round(userdetail.DataVolume * 1000).toString() + "MB";
        }
        

        let expiryDate = Date.parse(userdetail.ExpirationDate.toString());
        let daysLeft = Math.round((expiryDate - today) / millisecondsInDays);
        this.daysLeft = daysLeft < 0 ? "" : daysLeft + " days left"


        this.initloading = false;
      }, error => {
        this.toastr.error(environment.GenericErrorMsg, "Error");
      });
  }

  setStatus(accountState) 
  {
    switch (accountState) {
      case 0: {
        this.planstatus = "Blocked";
        break;
      }
      case 1: {
        this.planstatus = "Active";
        break;
      }
      case 2: {
        this.planstatus = "ZeroBalance";
        break;
      }
      case 3: {
        this.planstatus = "Expired";
        break;
      }
      default: {

        break;
      }

    }

  }
  ngOnInit() {
  

    this.usageForm = this.fb.group({
     
     
      dateRange: new FormControl('', [Validators.required]),
     

    });


  }




  generateReports()
  {
    let  startDate =this.startdate;
    let  endDate = this.enddate;


    
    var icustomer = this. currentUser.i_Customer  ;
    if(this.selectedAccount==0)
    {
      this.toastr.error("Please selectt an account");
      return;

    }
    if(!startDate     || !this.enddate)
    {
      this.toastr.error("Start and End Date is required.");
      return;
    }
    var iAccount=this. selectedAccount;
     
    this.LoadUsage(iAccount,   parseInt(icustomer), startDate, endDate);
    this.LoadPayments(iAccount,parseInt(icustomer) ,  startDate, endDate);
    
  }


  async LoadUsage(iAccount: number,icustomer:number, startDate:Date,endDate:Date)
  {
  


   var som =  await this.reportsService.LTEGetUsageReport(iAccount, icustomer, startDate, endDate).toPromise();
   this.  useagedata = som.Result;
//console.log(this.useagedata);
  // 
 

  }
async  LoadPayments(iAccount, icustomer:number, startDate:Date,endDate:Date)
  {
   

    let usageRequests : UsageRequests = {} as UsageRequests;
    usageRequests.EndDate = endDate;
    usageRequests.StartDate = startDate;
    usageRequests.Customer = icustomer.toString();
    usageRequests.Accounts=icustomer + "-" + iAccount;
    usageRequests.OperatorCode = environment.OperatorID;

    if (usageRequests.Accounts ==("0-0"))
      {usageRequests.Accounts = "0";}
    

     //
      let payment :PaymentModel [] =[];
      let allocations :PaymentModel [] =[];
     
     /*
      if (usageRequests.Accounts = "0")
     {
       

          var som =  await this.reportsService.GetCustomerPayments(icustomer.toString(),   startDate, endDate).toPromise();
            payment = som.Result;

 

            var somelo =  await this.reportsService.GetCustomerAllocations(icustomer.toString(),   startDate, endDate).toPromise();
            payment = somelo.Result;

     }
      else
      {
        
       

          var aloc =  await this.reportsService.GetAccountPayments(iAccount,   startDate, endDate).toPromise();
          payment = aloc.Result;
          

            var alocs =  await this.reportsService.GetAccountAllocations(iAccount,   startDate, endDate).toPromise();
            allocations = aloc.Result;

  
      }*/

      var aloc =  await this.reportsService.GetAccountPayments(iAccount,   startDate, endDate).toPromise();
      payment = aloc.Result;
      

        var alocs =  await this.reportsService.GetAccountAllocations(iAccount,   startDate, endDate).toPromise();
        allocations = alocs.Result;
      
      let ret :Payments [] =[];
   

      if (payment)
      {
        payment.forEach(pay=> {
       
          let vv = Utilities.MapPayment(pay);

          ret.push(vv);
        })
      }

      let payme : Payments = {} as Payments;
      payme.Description= "Total Amount";

    var totalamt:number =     payment.reduce(function(prev, cur) {
      return prev + cur.Amount;
    }, 0);

    var cred :number =     payment.reduce(function(prev, cur) {
      return prev + cur.CreditedAmount;
    }, 0);

    payme.CreditedAmount=cred;
    payme.Amount=totalamt;
    ret.push(payme);


  if (allocations)
  {
    var dealersallocationsonly  = allocations.filter(x => x.DealerUserID !=null)
    if(dealersallocationsonly.length>0)
    {

      dealersallocationsonly.forEach(paym=> {
       
        let vv = Utilities.MapPayment(paym);

        ret.push(vv);
      })


      let paymm : Payments = {} as Payments;
      paymm.Description= "Total Amount";

    var totalamt:number =     allocations.reduce(function(prev, cur) {
      return prev + cur.Amount;
    }, 0);

    var cred :number =     allocations.reduce(function(prev, cur) {
      return prev + cur.CreditedAmount;
    }, 0);

    paymm.CreditedAmount=cred;
    paymm.Amount=totalamt;
    ret.push(paymm);




    }

  }

  this.paymentdata = ret;

  }





}
